import type { pdfjs } from "./pdfjsRuntime";

/**
 * pdf.js (≈ 0,5 MB) erst laden, wenn tatsächlich ein PDF angezeigt oder gedruckt wird. Ein
 * statischer Import zieht die Bibliothek in den Startpfad jeder Seite, die eine Vorschau nur
 * enthalten könnte. Die Worker-Registrierung bleibt in `pdfjsRuntime.ts`.
 */
export type PdfjsModule = typeof pdfjs;
export type PdfLoadingTask = ReturnType<PdfjsModule["getDocument"]>;
export type PdfDocumentProxy = Awaited<PdfLoadingTask["promise"]>;

export function loadPdfjs(): Promise<PdfjsModule> {
  return import("./pdfjsRuntime").then((module) => module.pdfjs);
}
